"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _itemselectorlist_styles = _interopRequireDefault(require("./itemselectorlist_styles"));

var _itemselectorlist_definition = _interopRequireDefault(require("./itemselectorlist_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/* ========== ~~~~~~~~~~ EXPORT : ITEM SELECTOR LIST ~~~~~~~~~~ ========== */


var ItemSelectorList = (0, _reactJss.default)(_itemselectorlist_styles.default)(function (props) {
  // item state
  var _useState = (0, _react.useState)(props.items),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      updateItems = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _index2.sortArrayOfObjectsAlphabetically)(items, 'text')),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredItems = _useState4[0],
      updateFilteredItems = _useState4[1]; // select item functions


  var handleSelectedItem = function handleSelectedItem(e) {
    var selectedItem = e.target.classList.contains('item') ? e.target : e.target.parentNode.closest('.item');
    var selectedItemText = selectedItem.querySelector('.text').innerHTML;

    var getIndex = function getIndex() {
      return items.findIndex(function (item) {
        return item.text === selectedItemText;
      });
    };

    var itemIsAlreadySelected = function itemIsAlreadySelected() {
      return items[getIndex()].selected;
    };

    var newItemsArr = _toConsumableArray(items);

    newItemsArr[getIndex()].selected = itemIsAlreadySelected() ? false : true;
    props.handleSelectedItem && props.handleSelectedItem(selectedItem, selectedItemText, getIndex(), itemIsAlreadySelected());
    updateItems(newItemsArr);
  }; // render item markup functions


  var renderAllItems = function renderAllItems(selected) {
    return filteredItems.map(function (item) {
      return _react.default.createElement("div", {
        className: "item ".concat(item.selected && 'selected'),
        onClick: handleSelectedItem
      }, _react.default.createElement("span", {
        className: 'text'
      }, item.text), _react.default.createElement(_index.Icon, {
        name: 'check-circle',
        animation: 'none'
      }));
    });
  };

  var renderSelectedItems = function renderSelectedItems() {
    return items.map(function (item) {
      return !item.selected ? null : _react.default.createElement("div", {
        className: 'item',
        onClick: handleSelectedItem
      }, _react.default.createElement(_index.Icon, {
        name: 'check-circle',
        animation: 'none'
      }), _react.default.createElement("span", {
        className: 'text'
      }, item.text), _react.default.createElement(_index.Icon, {
        name: 'times-circle',
        animation: 'none'
      }));
    });
  }; // handles search


  var handleSearch = function handleSearch(searchText) {
    var foundArrayItems = items.filter(function (item) {
      return item.text.toLowerCase().includes(searchText.toLowerCase());
    });
    updateFilteredItems(foundArrayItems);
    props.handleSearchOnChange && props.handleSearchOnChange(searchText, foundArrayItems);
  }; // render component


  return _react.default.createElement("div", {
    className: "itemselectorlists ".concat(props.classes.itemselectorlists)
  }, _react.default.createElement("div", {
    className: 'itemselectorlist allitems'
  }, props.allItemsListTitle && _react.default.createElement("h2", null, props.allItemsListIcon && _react.default.createElement(_index.Icon, {
    name: props.allItemsListIcon,
    animation: 'none'
  }), " ", props.allItemsListTitle), _react.default.createElement("div", {
    className: 'itemlist'
  }, props.hasSearchBar && _react.default.createElement(_index.SearchBar, {
    type: 'search',
    placeholder: props.searchPlaceholderText,
    onChange: handleSearch
  }), _react.default.createElement("div", {
    className: 'items'
  }, renderAllItems()))), _react.default.createElement("div", {
    className: 'itemselectorlist selecteditems'
  }, props.selectedItemsListTitle && _react.default.createElement("h2", null, props.selectedItemsListIcon && _react.default.createElement(_index.Icon, {
    name: props.selectedItemsListIcon,
    animation: 'none'
  }), " ", props.selectedItemsListTitle), _react.default.createElement("div", {
    className: 'itemlist'
  }, _react.default.createElement("div", {
    className: 'items'
  }, renderSelectedItems()))));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(ItemSelectorList, _itemselectorlist_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = ItemSelectorList;
exports.default = _default;